var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "edit-icon",
    d: "M887.454,1217.9a10,10,0,1,0,10,10A10,10,0,0,0,887.454,1217.9Zm3.252,3.969a1.213,1.213,0,0,1,1.714,0l.65.65a1.219,1.219,0,0,1,0,1.719l-.912.917-2.369-2.369Zm-6.3,11.036-2.918.549.549-2.913,6.7-6.69,2.364,2.364Z",
    transform: "translate(-877.454 -1217.896)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.37217b016defada5f8c5e372280136e2.svg";
export { ForwardRef as ReactComponent };